<div class="tt-o-header" :class="{'tt-o-header--with-border': withBorder, 'tt-o-header--center': center}">
  <div class="tt-o-header__heading" role="heading" :aria-level="globalConfig.modalHeadingLevel" v-html="heading"></div>
  <p v-if="description" class="tt-o-header__text" v-html="description"></p>
</div>
